<script setup lang="ts">

</script>

<template>
  <div class=" mx-auto" style="max-width: 1920px;">
    <slot/>
  </div>

</template>
